import React, { useEffect, useState } from 'react';
import {
  Container, LoadingBounce, Panel,
} from '@michelin/acid-components';
import {
  Grid, Paper,
} from '@material-ui/core';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { useHistory, useParams } from 'react-router-dom';
import { PageTitle } from 'Utils/CanvasPageTitle';
import { UploadForm } from './UploadForm';
import { PromoItem, useGetPromos } from '../../../hooks/useAdminQueries';
import { PlainMessage } from '../../PlainMessage';
import { FileInfo } from './FileInfo';

const SelfServicePromoCodes = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const permissions = usePermissions();
  const promosList = useGetPromos();
  const { btNumber } = useParams<{ btNumber: string }>();

  const [pendingPromos, setPendingPromos] = useState<PromoItem[]>([]);
  const [allPromos, setAllPromos] = useState<PromoItem[]>([]);
  const [uploadDisabled, setUploadDisabled] = useState<boolean>(false);

  if (!permissions.allowsAction('admin_features.self_service_promo_upload')) history.push(`/${btNumber}`);

  useEffect(() => {
    setUploadDisabled(promosList?.data?.data?.some((promo: PromoItem) => promo.status === 'pending' || promo.status === 'processing') || false);
    setPendingPromos(promosList?.data?.data?.filter((promo: PromoItem) => promo.status === 'pending' || promo.status === 'processing') || []);
    setAllPromos(promosList?.data?.data?.filter((promo: PromoItem) => promo.status !== 'pending' && promo.status !== 'processing') || []);
  }, [promosList.data, promosList.dataUpdatedAt]);

  if (promosList.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;

  return (
    <>
      <PageTitle
        title={t('Admin Features')}
        subtitle={t('Self Service Promo Codes Upload')}
        goHomeBtn
      />
      <Container>
        <Paper>
          {promosList.isError ? (
            <Panel>
              <PlainMessage
                title={t('Error')}
                messages={t('Please check your connection and try again.').split('\n')}
              />
            </Panel>
          ) : (
            <Panel>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <UploadForm
                    onChange={() => {
                      setUploadDisabled(true);
                      promosList.refetch();
                    }}
                    disabled={uploadDisabled}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {pendingPromos?.length
                    ? (
                      <Panel title={t('Pending and Processing')} spacing={0}>
                        <Grid container spacing={2}>
                          {pendingPromos.map((promo: PromoItem) => (
                            <Grid item xs={12}>
                              <FileInfo promo={promo} />
                            </Grid>
                          ))}
                        </Grid>
                      </Panel>
                                        )
                    : null}
                </Grid>
                <Grid item xs={12}>
                  {allPromos?.length
                    ? (
                      <Panel title={t('Recently Processed Files')} spacing={0}>
                        <Grid
                          container
                          spacing={2}
                        >
                          {allPromos.map((promo: PromoItem) => (
                            <Grid item xs={12} sm={6}>
                              <FileInfo promo={promo} />
                            </Grid>
                          ))}
                        </Grid>
                      </Panel>
                    ) : null}
                </Grid>
              </Grid>
            </Panel>
          )}
        </Paper>
      </Container>
    </>
  );
};

export {
  SelfServicePromoCodes,
};
